import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UsersFacade } from '@app/shared/+state/users';
import { UserTrialConnectAccountCta } from '@app/shared/interfaces';
import { SegmentEvent, SegmentIoService } from '@app/shared/services/segmentIo/segment-io.service';
import { Observable } from 'rxjs';

@Component({
  standalone: false,
  selector: 'sbnb-demo-properties',
  templateUrl: './properties.component.html',
  styleUrls: ['./properties.component.scss', './properties.component.mobile.scss'],
})
export class DemoPropertiesComponent implements OnInit {
  isImageLoaded = false;
  userTrialConnectAccountCta$: Observable<UserTrialConnectAccountCta>;

  constructor(
    private readonly usersFacade: UsersFacade,
    private segmentIoService: SegmentIoService,
    private router: Router
  ) { }

  ngOnInit() {
    this.userTrialConnectAccountCta$ = this.usersFacade.userTrialConnectAccountCta$;
  }

  clickedPrimaryCta(url: string) {
    if (url) {
      this.segmentIoService.track(SegmentEvent.ClickedTrialBannerPrimaryCta, { url: this.router.url });
      this.router.navigateByUrl(url);
    }
  }

  clickedSecondaryCta(url) {
    if (url) {
      this.segmentIoService.track(SegmentEvent.ClickedTrialBannerSecondaryCta, { url: this.router.url });
      window.open(url, '_blank');
    }
  }
}
